import React from 'react';
import { FaFacebook, FaInstagram} from 'react-icons/fa';

const iconStyle = (Icon) => <Icon />;

export const footerSocialData = [
	{
		name: 'Facebook',
		icon: iconStyle(FaFacebook),
	}
];

export const footerSocialData2 = [
	{
		name: 'Instagram',
		icon: iconStyle(FaInstagram),
	}
];

export const footerData = [
	{
		title: 'Rechtliches',
		links: ['Impressum'],
	}
];